import React from 'react';
import styled from 'styled-components';
import { EyecandyEmptyList, EyecandyEmptySearch } from '../Icons';
import { EmptyStatesLayout } from '../Layout/EmptyStatesLayout';
import { Heading4 } from '../Typography/Heading';

const { NoContentWrapper, NoContentContentWrapper } = EmptyStatesLayout;

const EmptyMessage = styled(Heading4)`
  margin-bottom: 15px;

  &.no-data {
    font-weight: var(--font-weight-regular);
  }
`;

const EmptyDetails = styled.p`
  color: var(--greyscale-blackish);
  font-size: initial;
  line-height: var(--font-line-height-regular);
  overflow-wrap: break-word;
  text-align: center;
  white-space: pre-line;
`;

export const NoContentComponent = ({ message, topic, hasActiveFilters, searchTerm }) => {
  const hasActiveSearchOrFilters = searchTerm || hasActiveFilters;
  const EmptyIcon = hasActiveSearchOrFilters ? EyecandyEmptySearch : EyecandyEmptyList;

  const renderEmptyMessage = (
    <EmptyMessage className={!hasActiveSearchOrFilters && 'no-data'}>
      {!hasActiveSearchOrFilters ? message : 'Kein Ergebnis.'}
    </EmptyMessage>
  );

  const emptyDetails = () => {
    const messageFiltersAndSearch = `Zu dem gesuchten Begriff "${searchTerm}" und den ausgewählten Filtern wurden keine ${topic} gefunden.`;
    const messageSearch = `Zu dem gesuchten Begriff "${searchTerm}" wurden keine ${topic} gefunden.`;
    const messageFilters = `Zu den ausgewählten Filtern wurden keine ${topic} gefunden.`;

    let emptyMessage = '';
    if (searchTerm && hasActiveFilters) emptyMessage = messageFiltersAndSearch;
    else if (searchTerm && !hasActiveFilters) emptyMessage = messageSearch;
    else if (!searchTerm && hasActiveFilters) emptyMessage = messageFilters;
    return emptyMessage;
  };

  return (
    <NoContentWrapper>
      <NoContentContentWrapper>
        <EmptyIcon />
        {renderEmptyMessage}
        <EmptyDetails>{emptyDetails()}</EmptyDetails>
      </NoContentContentWrapper>
    </NoContentWrapper>
  );
};
